export default {
  addToCartAsync,
  setErrorMessages,
  setSuccessMessages,
  setUpdateUserMessages,
  setErrorOrSuccessMessages,
};

async function addToCartAsync(
  element,
  sku,
  gtmName,
  gtmCategory,
  gtmPrice,
  gtmMemberPrice,
  gtmId,
  shoppingCartAddUrl,
  gtmAddToCartEventName,
  alreadyAddedText
) {
  const url = shoppingCartAddUrl;
  let addedSkuItems = [];
  let addedSkuItemsCount = 0;

  let success = true;

  await fetch(url, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      sku: sku,
    }),
  })
    .then((response) => {
      if (response.status >= 200 && response.status < 300) {
        return response.json();
      }
    })
    .then((data) => {
      if (!data.success) {
        setErrorMessages(data.errorMessages);
        success = false;
      } else {
        addedSkuItems = data.payload.addedSkuItems;
        addedSkuItemsCount = data.payload.addedSkuItemsCount;
      }
    })
    .catch((error) => {
      console.log(error);
    });

  if (!success) {
    element.classList.remove("button__loader");
    return;
  }

  //Fire GTM Event
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "addToCart",
    ecommerce: {
      currencyCode: "EUR",
      add: {
        products: [
          {
            id: gtmId,
            name: gtmName,
            category: gtmCategory,
            price: gtmPrice,
            memberPrice: gtmMemberPrice,
            quantity: 1,
          },
        ],
      },
    },
  });

  if (gtmAddToCartEventName) {
    window.dataLayer.push({
      event: gtmAddToCartEventName,
    });
  }

  element.classList.remove("button__loader");
  element.classList.add("button__check");

  if (addedSkuItems && addedSkuItems.length && addedSkuItemsCount > 0) {
    $("#added-to-products").foundation("open");

    let addedProductsContent = document.getElementById(
      "added-to-products-content"
    );
    [].forEach.call(addedSkuItems, (skuItem) => {
      addProductToReveal(skuItem, addedProductsContent);

      const buttons = document.querySelectorAll(`.add-to-cart-${skuItem.id}`);
      [].forEach.call(buttons, (button) => {
        button.setAttribute("disabled", "");
        button.innerHTML = alreadyAddedText;
      });
    });

    const mobileMenuBasket = document.getElementById("mobile-menu-basket");
    mobileMenuBasket.classList.add("is-active");

    const miniCartCounts = document.querySelectorAll(".mini-cart__count");
    [].forEach.call(miniCartCounts, (miniCartCount) => {
      miniCartCount.classList.add("is-active");
      miniCartCount.innerHTML =
        parseInt(miniCartCount.innerHTML) + addedSkuItemsCount;
    });
  }

  setTimeout(function () {
    element.classList.remove("button__check");
    element.setAttribute("disabled", "");
    element.innerHTML = alreadyAddedText;
  }, 2000);
}

function addProductToReveal(product, element) {
  if (!product.name) {
    return;
  }

  let productElement = document.createElement("span");
  productElement.classList.add("added-to-products__product");

  let productLabel = document.createElement("span");
  productLabel.classList.add("added-to-products__product-label");
  productLabel.innerHTML = product.type + ": ";

  let productValue = document.createElement("span");
  productValue.classList.add("added-to-products__value");
  productValue.innerHTML = product.name;

  productElement.appendChild(productLabel);
  productElement.appendChild(productValue);
  element.appendChild(productElement);
}

function setErrorMessages(errorMessages) {
  let errorMessageString = "";
  for (const errorMessage of errorMessages) {
    errorMessageString += "<p>" + errorMessage + "</p>";
  }

  document.getElementById("errorMessages").innerHTML = errorMessageString;
  document.getElementById("errorMessageContainer").style.display = "block";
}

function setSuccessMessages(successMessages) {
  let successMessageString = "";
  for (const successMessage of successMessages) {
    successMessageString += "<p>" + successMessage + "</p>";
  }

  document.getElementById("successMessages").innerHTML = successMessageString;
  document.getElementById("successMessageContainer").style.display = "block";
}

function setUpdateUserMessages(data) {
  document.getElementById("errorMessageContainer").style.display = "none";
  document.getElementById("successMessageContainer").style.display = "none";

  document
    .getElementById("changeAccountSubmit")
    .classList.remove("button__loader");

  if (data.success) {
    setSuccessMessages(data.success);
  } else {
    setErrorMessages(data.errors);
  }
}

function setErrorOrSuccessMessages(data) {
  document.getElementById("errorMessageContainer").style.display = "none";
  document.getElementById("successMessageContainer").style.display = "none";

  if (data.success) {
    setSuccessMessages(data.success);
  } else {
    setErrorMessages(data.errors);
  }
}
